/**
 * @generated SignedSource<<a4d12bdcfa8d54387e4c3572e7a5c58e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceArchivedRoutinesList_archiveRoutines$data = {
  readonly archivedRoutines: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly id: string;
        readonly lastWorkspaceOccasion: {
          readonly id: string;
          readonly sequenceNumber: number;
        } | null;
        readonly title: string;
        readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutinesListItemContent_routine">;
      };
    }>;
  };
  readonly hasArchivedRoutine: boolean | null;
  readonly id: string;
  readonly " $fragmentType": "WorkspaceArchivedRoutinesList_archiveRoutines";
};
export type WorkspaceArchivedRoutinesList_archiveRoutines$key = {
  readonly " $data"?: WorkspaceArchivedRoutinesList_archiveRoutines$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceArchivedRoutinesList_archiveRoutines">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "archivedRoutines"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "query"
    },
    {
      "kind": "RootArgument",
      "name": "workspaceId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./WorkspaceArchivedRoutinesList_WorkspaceRefetchQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "WorkspaceArchivedRoutinesList_archiveRoutines",
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasArchivedRoutine",
      "storageKey": null
    },
    {
      "alias": "archivedRoutines",
      "args": [
        {
          "kind": "Variable",
          "name": "query",
          "variableName": "query"
        }
      ],
      "concreteType": "RoutineWorkspaceConnection",
      "kind": "LinkedField",
      "name": "__WorkspaceArchivedRoutinesList_archiveRoutines_archivedRoutines_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineWorkspaceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Routine",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WorkspaceRoutinesListItemContent_routine"
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "workspaceId",
                      "variableName": "workspaceId"
                    }
                  ],
                  "concreteType": "RoutineWorkspaceOccasion",
                  "kind": "LinkedField",
                  "name": "lastWorkspaceOccasion",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sequenceNumber",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};
})();

(node as any).hash = "4f0ea2f65fdce32ae8902572e0c75d59";

export default node;
